module.exports = __webpack_public_path__ + "9fd5a35da82dd0e222074ec819429a56.pdf";